module.exports = __webpack_public_path__ + "assets/9493a4d6c926a47a5cdb7ace850af67b.png";